export default __webpack_public_path__ + "static/Video-0eb921146e5c9258fe3d6017f2593236.jpg";